import React from 'react';
import CookieService from 'hb-redux-store/util/cookieService';
import request from 'hb-redux-store/util/request';
import config from 'appConfig';
import { getDeviceType } from '../../hb-redux-store/util/DeviceDetectionService';

class Demo extends React.Component {
  constructor(props) {
    super(props);
    const secrets = [];
    secrets.push({
      key: 'Visitor Id: ',
      value: CookieService.get('VISITOR_ID'),
    });
    secrets.push({ key: 'Device Id: ', value: config.getDeviceId() });
    secrets.push({ key: 'hbpt: ', value: CookieService.get('hbpt') });
    secrets.push({ key: 'device UA: ', value: navigator.userAgent });
    secrets.push({ key: 'deviceType: ', value: getDeviceType() });
    // secrets.push({
    //   key: 'Secure Session Id',
    //   value: CookieService.get('SecureSessionId'),
    // });
    this.state = {
      secrets,
    };
  }
  componentDidMount() {
    request
      .post('/api/getDeliverySlots')
      .then(({ data }) => {
        this.setState({
          secrets: [
            ...this.state.secrets,
            { key: 'Cart Id', value: data.shoppingCartId },
            { key: 'ADC Code', value: data.adcCode },
          ],
        });
      })
      .catch(e => console.log('Err: in demo page:', e));
  }

  render() {
    return (
      <div>
        {/*<h1 className="primary-text-regular">This is regular primary text</h1>*/}
        {/*<h1 className="primary-text-bold bold">This is bold primary text</h1>*/}
        {/*<h2> This is App.js</h2>*/}
        {/*<p>Set up structure and/or routes here</p>*/}
        {/*<br />*/}
        {/*<br />*/}
        {/*<br />*/}
        <br />
        <table className="std-margin-lr demo-table">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {this.state.secrets.map(({ key, value }, i) => (
              <tr key={i}>
                <td>{key}</td>
                <td>{value}</td>
              </tr>
            ))}
            <tr>
              <td>App Homepage Deep link</td>
              <td>
                <a href="intent://home#Intent;scheme=halalbox;package=com.halalboxapp;S.browser_fallback_url=http%3A%2F%2dev.myhalalbox.in/;end">
                  Open Halalbox App Home Screen
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Demo;
